var VideoComponents = {
    version: '1.0',
    author: 'CAA Digital',
    project: 'Video Components for CAASCO',
    Date: 'Sep 2020',

    //initialization 
    init: function () {
        var context = this;
        //Global variables
        context.config = {};

        //Call DOM invoking functions here
        context.onDomReady();
        context.eventHandlers();

    },

    onDomReady: function () {
        var context = this;

        //Load all functions
        context.onVideoElementClicked = function(videoWrapper, image, play_button, player, player_class, parent_class, image_class, event, video_type) {

            if (video_type == "main") {
                play_button.hide();
            }
            else { //when "described video" button is clicked
                var mainLabel = play_button.attr("orig-video-label");
                var descLabel = play_button.attr("desc-video-label");
                var mainIframe = play_button.parent().siblings().find("iframe[video-type='main']");
                var descIframe = play_button.parent().siblings().find("iframe[video-type='desc']");
                videoWrapper.find("button").hide();

                if (play_button.html() === descLabel) { // play described video
                    play_button.html(mainLabel);
                    //player = descIframe;
                    !mainIframe.hasClass(player_class) ? mainIframe.addClass(player_class) : null;
                    context.toggleAutoPlay(mainIframe);
                }
                else { // play original video
                    play_button.html(descLabel);
                    player = mainIframe;
                    !descIframe.hasClass(player_class) ? descIframe.addClass(player_class) : null;
                    context.toggleAutoPlay(descIframe);
                }
            }
            //common actions for all videos
            player.removeClass(player_class);
            videoWrapper.addClass(parent_class);
            image.addClass(image_class);
            player.attr("tabindex", "-1");
            //player.focus();
            setTimeout(function(){ player.focus(); }, 300);
            //---

            if(player.attr('src').indexOf('autoplay=') == -1) {
                var $separator = player.attr('src').indexOf('?') >= 0 ? "&" : "?";
                player.attr('src', player.attr('src') + $separator +'autoplay=1&loop=1&mute=1&rel=0&wmode=transparent');
            }
            else {
                context.toggleAutoPlay(player);
            }
            event.preventDefault();

        },

        context.toggleAutoPlay = function(player) {
            if (player.attr('src').indexOf('autoplay=1') > -1) { //check if autoplay is enabled
                player.attr('src', player.attr('src').replace('autoplay=1', 'autoplay=0'));
            }
            else {
                player.attr('src', player.attr('src').replace('autoplay=0', 'autoplay=1'));
            }
        }

    },

    //Handle all page level events
    eventHandlers: function () {
        var context = this;

        jQuery('body').on('click', '.half-video__play-button', function(e){
            var $play_button = jQuery(this),
                $main = $play_button.closest('.half-video__video-wrapper'),
                $image = $main.find('.half-video__preview-image'),
                $player = $main.find('.half-video__iframe'),
                class_to_remove_player = "half-video__iframe--hide",
                class_to_add_parent = "half-video__video-container--no-mask",
                class_to_add_image = "half-video__preview-image--hide",
                $event = e;

            context.onVideoElementClicked($main, $image, $play_button, $player, class_to_remove_player, class_to_add_parent, class_to_add_image, $event, "main");
        });

        jQuery('body').on('click', '.half-video-desc__play-button', function(e){
            var $play_button = jQuery(this),
                $main = $play_button.parent().siblings('.half-video__video-wrapper'),
                $image = $main.find('.half-video__preview-image'),
                $player = $main.find('.half-video-desc__iframe'),
                class_to_remove_player = "half-video__iframe--hide",
                class_to_add_parent = "half-video__video-container--no-mask",
                class_to_add_image = "half-video__preview-image--hide",
                $event = e;

            context.onVideoElementClicked($main, $image, $play_button, $player, class_to_remove_player, class_to_add_parent, class_to_add_image, $event, "desc");
        });

        jQuery('body').on('click', '.video__play-button', function(e){
            var $play_button = jQuery(this),
                $main = $play_button.closest('.video__iframe-container'),
                $image = $main.find('.video__preview-image'),
                $player = $main.find('.video__iframe'),
                class_to_remove_player = "video__iframe--hide",
                class_to_add_parent = "video__iframe-container--no-mask",
                class_to_add_image = "video__preview-image--hide",
                $event = e;

            context.onVideoElementClicked($main, $image, $play_button, $player, class_to_remove_player, class_to_add_parent, class_to_add_image, $event, "main");
        });

        jQuery('body').on('click', '.video-desc__play-button', function(e){
            var $play_button = jQuery(this),
                $main = $play_button.parent().siblings('.video__iframe-container'),
                $image = $main.find('.video__preview-image'),
                $player = $main.find('.video-desc__iframe'),
                class_to_remove_player = "video__iframe--hide",
                class_to_add_parent = "video__iframe-container--no-mask",
                class_to_add_image = "video__preview-image--hide",
                $event = e;

            context.onVideoElementClicked($main, $image, $play_button, $player, class_to_remove_player, class_to_add_parent, class_to_add_image, $event, "desc");
        });

        jQuery('body').on('click', '.feature-cards__play-button', function(e){
            var $play_button = jQuery(this),
                $main = $play_button.closest('.feature-cards__video-wrapper'),
                $image = $main.find('.feature-cards__preview-image'),
                $player = $main.find('.feature-cards__iframe'),
                class_to_remove_player = "feature-cards__iframe--hide",
                class_to_add_parent = "remove-overlay",
                class_to_add_image = "feature-cards__preview-image--hide",
                $event = e;

            context.onVideoElementClicked($main, $image, $play_button, $player, class_to_remove_player, class_to_add_parent, class_to_add_image, $event, "main");
        });

        jQuery('body').on('click', '.feature-cards-desc__play-button', function(e){
            var $play_button = jQuery(this),
                $main = $play_button.parent().siblings('.feature-cards__video-wrapper'),
                $image = $main.find('.feature-cards__preview-image'),
                $player = $main.find('.feature-cards-desc__iframe'),
                class_to_remove_player = "feature-cards__iframe--hide",
                class_to_add_parent = "remove-overlay",
                class_to_add_image = "feature-cards__preview-image--hide",
                $event = e;

            context.onVideoElementClicked($main, $image, $play_button, $player, class_to_remove_player, class_to_add_parent, class_to_add_image, $event, "desc");
        });

        jQuery('body').on('click', '.blog-video__play-button', function(e){
            var $play_button = jQuery(this),
                $main = $play_button.closest('.blog-video__iframe-container'),
                $image = $main.find('.blog-video__preview-image'),
                $player = $main.find('.blog-video__iframe'),
                class_to_remove_player = "blog-video__iframe--hide",
                class_to_add_parent = "blog-video__iframe-container--no-mask",
                class_to_add_image = "blog-video__preview-image--hide",
                $event = e;

            context.onVideoElementClicked($main, $image, $play_button, $player, class_to_remove_player, class_to_add_parent, class_to_add_image, $event, "main");
        });

        jQuery('body').on('click', '.blog-video-desc__play-button', function(e){
            var $play_button = jQuery(this),
                $main = $play_button.parent().siblings('.blog-video__iframe-container'),
                $image = $main.find('.blog-video__preview-image'),
                $player = $main.find('.blog-video-desc__iframe'),
                class_to_remove_player = "blog-video__iframe--hide",
                class_to_add_parent = "blog-video__iframe-container--no-mask",
                class_to_add_image = "blog-video__preview-image--hide",
                $event = e;

            context.onVideoElementClicked($main, $image, $play_button, $player, class_to_remove_player, class_to_add_parent, class_to_add_image, $event, "desc");
        });

        jQuery('body').on('click', '.video-accordion__play-button' , function(e){
            var $play_button = jQuery(this),
                $main = $play_button.closest('.video-accordion__video-container'),
                $image = $main.find('.video-accordion__preview-image'),
                $player = $main.find('.video-accordion__iframe'),
                class_to_remove_player = "video-accordion__iframe--hide",
                class_to_add_parent = "video-accordion__video-container--no-mask",
                class_to_add_image = "video-accordion__preview-image--hide",
                $event = e;

            context.onVideoElementClicked($main, $image, $play_button, $player, class_to_remove_player, class_to_add_parent, class_to_add_image, $event, "main");
        });

        jQuery('body').on('click', '.video-accordion-desc__play-button', function(e){
            var $play_button = jQuery(this),
                $main = $play_button.parent().siblings('.video-accordion__video-container'),
                $image = $main.find('.video-accordion__preview-image'),
                $player = $main.find('.video-accordion-desc__iframe'),
                class_to_remove_player = "video-accordion__iframe--hide",
                class_to_add_parent = "video-accordion__video-container--no-mask",
                class_to_add_image = "video-accordion__preview-image--hide",
                $event = e;

            context.onVideoElementClicked($main, $image, $play_button, $player, class_to_remove_player, class_to_add_parent, class_to_add_image, $event, "desc");
        });

    }
};

window.addEventListener("load", function () {
    VideoComponents.init();
});